import React, { useState } from "react";
import classes from "./SubscriptionForMoreDaysModal.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AutoRenewalModal from "./AutoRenewalModal";
import { increaseValidityApi, login } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify";
import { setUserDetails, setUserToken } from "../store/slices/userTokenSlice";
import SmallLoader from "./Loaders/SmallLoader";

const SubscriptionForMoreDaysModal = ({ setModal, expireTime }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state?.persisted?.userTokenSlice);
    console.log(userDetails, 'user details...');

    // const [autoRenewal, setAutoRenewal] = useState(false);
    const [autoRenewal, setAutoRenewal] = useState(true);
    const [autoRenewalModal, setAutoRenewalModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const toggleAutoRenewal = () => setAutoRenewal(!autoRenewal);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const response = await increaseValidityApi(userDetails?.msisdn, uuidv4(), autoRenewal ? "renewal" : "ondemand");
            // setLoading(false);

            if (response?.data?.status == 4) {
                toast.success(t("90"));
            }

            if (response?.data?.status == 3) {
                setLoading(false);
                toast.success(t("91"));
                navigate("/low-balance");
                return;
            }

            await login({ msisdn: userDetails?.msisdn })
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    dispatch(setUserDetails(res?.data?.result));
                    setModal(false);
                    window.location.href="/home";
                })
                .catch((err) => {
                    setLoading(false);
                    toast.error(t("92"));
                });

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else if (error?.response?.data?.status == 2) {
                toast.error(t("103"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            {autoRenewalModal ? (
                <AutoRenewalModal setModal={setAutoRenewalModal} />
            ) : (

                <div className={classes.container} onClick={() => setModal(false)}>
                    <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                        <div className={classes.info}>
                            <img
                                src="/assets/images/incentive.png"
                                alt="info"
                                className={classes.img}
                            />
                        </div>
                        <div className={classes.msg}>
                            <p className={classes.text}>{expireTime}</p>
                            <p className={classes.text_2}>
                                {t("118")}
                            </p>
                        </div>

                        <div className={classes.auto_renewal_container}>
                            <input type="checkbox" id="autoRenewal" name="Auto Renewal" value="Auto Renewal"
                                className={classes.check_box} checked={autoRenewal} onClick={toggleAutoRenewal}
                            >
                            </input>
                            <label for="terms" className={classes.check_box_label}>
                                <span className={classes.link} onClick={() => setAutoRenewalModal(true)}>{t("101")}</span>
                            </label>
                        </div>

                        <div className={classes.btns_container}>
                            <button className={classes.btn} type="button"
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? <SmallLoader /> :
                                    t("80")
                                }
                            </button>
                            <button
                                className={classes.btn_2}
                                type="button"
                                disabled={loading}
                                onClick={() => setModal(false)}
                            >
                                {t("81")}
                            </button>
                        </div>

                        {/* <button className={classes.btn_auto_renewal}>
                    {t("101")}
                </button> */}
                    </div>
                </div>
            )}
        </>

    );
};

export default SubscriptionForMoreDaysModal;